<template>
  <div class="process-status-form">
    <pt-form-item label="批量上传报告" labelWidth="140px" :required="true">
        <el-upload class="upload-demo" v-model="statusForm.reportFile" name="reportFile" v-validate="'required'" data-vv-as="报告"
        action="aaa"
        :auto-upload="false"
        :multiple="false"
        :on-change="changHandler"
        :on-remove="removeHandler">
            <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
    </pt-form-item>
    <el-dialog title="批量上传报告结果" :visible.sync="showDialog" width="50%">
      <h3>{{handleRes.message}}</h3>
      <div class="msgBox">
        <p v-for="(item,index) in handleRes.details" :key="index">
          {{item.message}}
        </p>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showDialog = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { validate } from 'utils/validate'
import { getSignature } from '@/utils/action'
import { formatDate } from '@/utils/formUtils'
// 组件class前缀
const prefixCls = 'pt-lab-samples-received-form'

export default {
  name: 'pt-lab-samples-received-form',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    value: {
      type: Object
    },
    isLoading: {
      type: Boolean
    }
  },
  data () {
    return {
      statusForm: JSON.stringify(this.value) !== '{}' ? this.value : {
        result: 'REPORT_GENERATE',
        reportFile: []
      },
      reportFile: [],
      showDialog: false,
      handleRes: {}
    }
  },
  watch: {
    isLoading (val) {
      if (val) {
        this.reportFile.splice(0, this.reportFile.length)
        console.log('this.reportFile', this.reportFile)
      }
    },
    statusForm: {
      handler: function (val, oldVal) {
        this.$emit('input', val)
      },
      deep: true
    },
    reportFile: {
      handler: function (val, old) {
        if (val.length > 1) {
          this.reportFile = val.slice(-1)
        }
      }
    }
  },
  methods: {
    formatDate,
    updateVisible (val) {
      this.showDialog = val
      if (!val) {
        // 更新表格数据
        this.$emit('updateTable', true)
        // 更新待处理订单数量，如若接口会返回该数据的话则不用
        this.$emit('updateAllSize', true)
      }
    },
    formValidate () {
      return validate(this, this.statusForm)
    },
    changHandler (file, fileList) {
      if (fileList.length > 1) {
        fileList.shift()
      }
      this.statusForm.reportFile = fileList
    },
    removeHandler (file, fileList) {

    },
    async submit () {
      try {
        let params = { resourceConfig: 'rawdata', type: 'PRIVATE_RESOURCE', objectId: formatDate(new Date()), name: this.statusForm.reportFile[0].raw.name }
        var response = await this.$store.dispatch('ossUploadBigFileAdult', params)
        console.log('response', response.data)
        try {
          let uploadData = new FormData()
          let file = this.statusForm.reportFile[0].raw

          uploadData.append('AccessKeyId', response.data.accesskeyid)
          uploadData.append('policy', response.data.policy)
          uploadData.append('signature', response.data.signature)
          uploadData.append('key', response.data.key)
          uploadData.append('content-type', response.data['content-type'])
          let saveFileName = (response.data.dir || 'rawdata/' + formatDate(new Date())) + '/' + file.name
          uploadData.append('file', file)
          // uploadData.append('success_action_status', 200) // 指定返回的状态码，默认为204
          let uploadRes = await getSignature(response.data.host, uploadData)
          if (uploadRes.status === 204) {
            let data = {
              ossUrl: 'rawdata/' + formatDate(new Date()) + '/' + file.name
            }
            return this.$store.dispatch('AdultUploadReport', data)
          } else {
            this.$emit('updateLoading', false)
            this.$message.error('文件上传失败')
          }
        } catch (err) {
          console.log(err)
          this.$emit('updateLoading', false)
          this.$message.error('文件上传失败！')
        }
      } catch (err) {
        console.log(err)
        this.$emit('updateLoading', false)
        this.$message.error('获取签名失败！')
      }
    },
    submitForm () {
      // this.submit()
      this.submit().then(data => {
        this.$emit('updateLoading', false)
        // this.$emit('getResult', response)
        this.showDialog = true
        console.log('response.data------', data)
        this.handleRes = data
      }).catch(err => {
        this.$emit('updateLoading', false)
        this.$message.error(err || '操作失败！')
      })
    }
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.process-status-form{
  margin:20px 0;
  el-textarea,.el-textarea__inner,.el-input__inner{
    width:500px;
  }
  .msgBox{
    max-height: 500px;
    overflow: auto;
  }
}
</style>
